import { FilePenRegularIcon } from "@elixir/icons";
import { Appointment } from "@elixir/types";
import { ChipWithTooltip } from "ui";
import { onAppointmentAction } from "../../../../utils/bridges/methods";

const Notes = ({
  apt,
  className = "",
  type,
}: {
  apt: Appointment;
  className?: string;
  type?: "primary" | "secondary";
}) => {
  return (
    <ChipWithTooltip
      onClick={() => {
        onAppointmentAction({
          a: apt,
          cId: apt.clinic_id,
          dontAllowStartVisit: true,
          isNotesMode: true,
        });
      }}
      className={`h-32 flex-1 ${className}`}
      icon={<FilePenRegularIcon className="dr-min-w-14 dr-h-14" />}
      title="Notes"
      tooltipText="Notes"
      type={type}
    />
  );
};

export default Notes;
